module.exports = __webpack_public_path__ + "static/media/productos_electricidad.da4fce8b.jpg";